{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Letöltés",
      "UPLOADING": "Frissítés..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Elküldés"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Üzenet elküldése újból",
      "ERROR_MESSAGE": "Nem sikerült az elküldés, kérjük próbáld később"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Not available"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Online vagyunk",
    "OFFLINE": "Jelenleg nem vagyunk elérhetőek",
    "BACK_AS_SOON_AS_POSSIBLE": "We will be back as soon as possible"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Néhány percen belül válaszol",
    "IN_A_FEW_HOURS": "Néhány órán belül válaszol",
    "IN_A_DAY": "Általánban egy napon belül válaszol",
    "BACK_IN_HOURS": "We will be back online in {n} hour | We will be back online in {n} hours",
    "BACK_IN_MINUTES": "We will be back online in {time} minutes",
    "BACK_AT_TIME": "We will be back online at {time}",
    "BACK_ON_DAY": "We will be back online on {day}",
    "BACK_TOMORROW": "We will be back online tomorrow",
    "BACK_IN_SOME_TIME": "We will be back online in some time"
  },
  "DAY_NAMES": {
    "SUNDAY": "vasárnap",
    "MONDAY": "hétfő",
    "TUESDAY": "kedd",
    "WEDNESDAY": "szerda",
    "THURSDAY": "csütörtök",
    "FRIDAY": "péntek",
    "SATURDAY": "szombat"
  },
  "START_CONVERSATION": "Beszélgetés megkezdése",
  "END_CONVERSATION": "Beszélgetés befejezése",
  "CONTINUE_CONVERSATION": "Beszélgetés folytatása",
  "YOU": "Ön",
  "START_NEW_CONVERSATION": "Új beszélgetés megkezdése",
  "VIEW_UNREAD_MESSAGES": "Olvasatlan üzenetei vannak",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Új üzenetek",
    "CLOSE_MESSAGES_BUTTON": "Bezárás",
    "COMPANY_FROM": "innen",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Chatelj velünk"
  },
  "POWERED_BY": "Chatwoot",
  "EMAIL_PLACEHOLDER": "Add meg az e-mailed",
  "CHAT_PLACEHOLDER": "Gépeld be üzeneted",
  "TODAY": "Ma",
  "YESTERDAY": "Tegnap",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Teljes név",
        "PLACEHOLDER": "Kérjük a teljes nevedet add meg",
        "REQUIRED_ERROR": "A teljes név megadása kötelező"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Email cím",
        "PLACEHOLDER": "Kérjük helyes e-mailcímet adj meg",
        "REQUIRED_ERROR": "Email cím megadása kötelező",
        "VALID_ERROR": "Kérjük helyes e-mailcímet adj meg"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefonszám",
        "PLACEHOLDER": "Kérlek add meg a telefonszámod",
        "REQUIRED_ERROR": "Telefonszám megadása kötelező",
        "DIAL_CODE_VALID_ERROR": "Kérlek válassz országot",
        "VALID_ERROR": "Kérlek egy valós telefonszámot adj meg",
        "DROPDOWN_EMPTY": "Nincs találat",
        "DROPDOWN_SEARCH": "Search country"
      },
      "MESSAGE": {
        "LABEL": "Üzenet",
        "PLACEHOLDER": "Írd be az üzeneted",
        "ERROR": "Az üzenet túl rövid"
      }
    },
    "CAMPAIGN_HEADER": "Kérjük a beszélgetés megkezdése előtt add meg neved és e-mail címed",
    "IS_REQUIRED": "kötelező",
    "REQUIRED": "Kötelező",
    "REGEX_ERROR": "Please provide a valid input"
  },
  "FILE_SIZE_LIMIT": "A file mérete meghaladja a {MAXIMUM_FILE_UPLOAD_SIZE} limitet",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Érvénytelen mező"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Emoji keresése",
    "NOT_FOUND": "Nem található emoji",
    "ARIA_LABEL": "Emoji picker"
  },
  "EMOJI_ICON_PICKER": {
    "SEARCH_EMOJI": "Search emoji…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "Nem található emoji"
  },
  "CSAT": {
    "TITLE": "Értékeld a beszélgetést",
    "SUBMITTED_TITLE": "Köszönjük, hogy elküldted az értékelést",
    "PLACEHOLDER": "Mondj nekünk többet..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Beszélgetés kivonat igénylése",
    "SEND_EMAIL_SUCCESS": "A beszélgetés jegyzet sikeresen elküldve",
    "SEND_EMAIL_ERROR": "Hiba történt, kérjük próbáld újra"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Kattints ide a csatlakozáshoz",
      "LEAVE_THE_ROOM": "Hívás elhagyása"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Népszerű cikkek",
    "VIEW_ALL_ARTICLES": "Mutasd az összes bejegyzést",
    "IFRAME_LOAD_ERROR": "Hiba történt a cikk betöltése során, kérjük, frissítse az oldalt, és próbálja meg újra."
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Képüzenet"
    },
    "audio": {
      "CONTENT": "Hangüzenet"
    },
    "video": {
      "CONTENT": "Videoüzenet"
    },
    "file": {
      "CONTENT": "Csatolt file"
    },
    "location": {
      "CONTENT": "Hely"
    },
    "fallback": {
      "CONTENT": "megosztott URL-t tartalmaz"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Válaszolva a következőre:"
  }
}
